import { cleanUrl } from './clean-url';
function isPagination(page) {
    return page.number !== undefined;
}
function isPaginationThrivaSerializable(page) {
    return page.limit !== undefined;
}
/**
 * Constructs the URL for the API request, adding JSON API parameters such as filters, includes and pagination details.
 *
 * @param apiPath - The API URL to use for the request.
 * @param apiOptions - The API options to add onto the request URL.
 * @returns A string
 */
export function buildAPIRequestUrl(apiPath, apiOptions) {
    let resultUrl = `${cleanUrl(apiPath)}`;
    if (apiOptions) {
        resultUrl += '?';
        // Pull out all of the posible API options, these are all optional
        const { filters, includes, fields, limit, page, customParams, sort } = apiOptions;
        if (limit && limit > 0) {
            resultUrl += `limit=${limit}&`;
        }
        if (filters) {
            filters.forEach(filter => {
                let filterValues = filter.filterValue;
                // Support multiple values for a filter e.g. filter[state_in]=active,pending
                if (Array.isArray(filterValues)) {
                    filterValues = filterValues.join(',');
                }
                resultUrl += `filter[${filter.filterAttribute}]=${filterValues}&`;
            });
        }
        if (includes && includes.length) {
            resultUrl += `include=${includes.join(',')}&`;
        }
        if (page) {
            if (isPaginationThrivaSerializable(page)) {
                resultUrl += (page.limit && `limit=${page.limit}`) || '';
                resultUrl += (page.offset && `&offset=${page.offset}&`) || '';
            }
            if (isPagination(page)) {
                resultUrl += `page[number]=${page.number}`;
                resultUrl += `&page[size]=${page.size}&`;
            }
        }
        if (fields) {
            fields.forEach(field => {
                resultUrl += `fields[${field.resourceType}]=${field.fieldNames.join(',')}&`;
            });
        }
        if (customParams) {
            customParams.forEach(param => {
                let paramValues = param.paramValue;
                // Support multiple values for a custom parameter e.g. state_in=active,pending
                if (Array.isArray(paramValues)) {
                    paramValues = paramValues.join(',');
                }
                resultUrl += `${param.paramName}=${paramValues}&`;
            });
        }
        if (sort) {
            resultUrl += `sort=${sort.join(',')}`;
        }
    }
    return cleanUrl(resultUrl);
}
//# sourceMappingURL=build-url.js.map